<template>
    <v-container>
        <h1 class="subtitle-1 grey--text mb-4">Raporte</h1>
        <v-row>
            <v-col>
        <v-card>
            <v-card-title>Descarcă situaţia veniturilor zilnice</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-menu
                            ref="menuSIZ"
                            v-model="dateMenuSIZopen"
                            :close-on-content-click="false"
                            :return-value.sync="dateSIZ"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateSIZ"
                                label="Data"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateSIZ" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="dateMenuSIZopen = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menuSIZ.save(dateSIZ)">OK</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            v-model="managerCompaniesSelectedSIZ"
                            :items="managerCompanies"
                            label="Companie"
                            item-text="companyName"
                            item-value="id"
                            :error="managerCompaniesSelectedSIZerror"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete
                            v-model="shopIdSIZ"
                            :items="shops"
                            item-text="name"
                            item-value="id"
                            clearable
                            placeholder="Toate agențiile"
                            label="Agenție"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-checkbox
                            v-model="detailedReportSIZ"
                            label="Situaţie detaliată"
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-btn 
                            dark 
                            @click.prevent="getSIZReport"
                            :loading="getSIZButtonLoading"
                            color="blue-grey"
                        >Descarcă
                        <v-icon right dark>mdi-file-pdf-box</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
        <v-card>
            <v-card-title>Descarcă situaţia veniturilor lunare</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-menu
                            ref="menuSIL"
                            v-model="dateMenuSILopen"
                            :close-on-content-click="false"
                            :return-value.sync="dateSIL"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateSIL"
                                label="Luna"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateSIL" no-title landscape="landscape" type="month" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="dateMenuSILopen = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menuSIL.save(dateSIL)">OK</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            v-model="managerCompaniesSelectedSIL"
                            :items="managerCompanies"
                            label="Companie"
                            item-text="companyName"
                            item-value="id"
                            :error="managerCompaniesSelectedSILerror"
                            :rules="rulesApplied"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete
                            v-model="shopIdSIL"
                            :items="shops"
                            item-text="name"
                            item-value="id"
                            clearable
                            placeholder="Toate agențiile"
                            label="Agenție"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-checkbox
                            v-model="detailedReportSIL"
                            label="Situaţie detaliată"
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-btn 
                            dark 
                            @click.prevent="getSILReport"
                            :loading="getSILButtonLoading"
                            color="blue-grey"
                        >Descarcă
                        <v-icon right dark>mdi-file-pdf-box</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col class="d-flex" cols="12" sm="3">
                
            </v-col>
            <v-col class="d-flex" cols="12" sm="3">
                
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

export default {
    
    data: () => {
        return {
            managerCompaniesSelectedSIZ: null,
            managerCompaniesSelectedSIZerror: null,
            managerCompaniesSelectedSIL: null,
            managerCompaniesSelectedSILerror: null,
            detailedReportSIZ: false,
            detailedReportSIL: false,
            dateSIZ: new Date().toISOString().substr(0, 10),
            dateSIL: new Date().toISOString().substr(0, 7),
            dateMenuSIZopen: false,
            dateMenuSILopen: false,
            shopIdSIZ: null,
            shopIdSIL: null,
            buttonLoading: false,
            getSIZButtonLoading: false,
            getSILButtonLoading: false,
            rulesApplied: [],
            rules: [
                v => !!v || 'Required.',
            ]
        }
    },
    computed: {
        managerCompanies(){
            return this.$store.getters['getManagerCompanies'];
        },
        shops(){
            return this.$store.getters['getShops'];
        }
    },
    methods: {
        getSIZReport(){
            if(this.managerCompaniesSelectedSIZ){
                this.getSIZButtonLoading = true;
                this.managerCompaniesSelectedSIZerror = false;
                this.$store.dispatch('situatiiContabile/getSIZReport', {
                    date: this.$moment(this.dateSIZ).format('YYYY-MM-DD'),
                    shopId: this.shopIdSIZ,
                    companyId: this.managerCompaniesSelectedSIZ,
                    withDetails: this.detailedReport
                }).then(()=>{
                    this.getSIZButtonLoading = false;
                });
            }else{
                this.managerCompaniesSelectedSIZerror = true;
            }
        },
        getSILReport(){
            if(this.managerCompaniesSelectedSIL){
                this.getSILButtonLoading = true;
                this.managerCompaniesSelectedSILerror = false;
                this.$store.dispatch('situatiiContabile/getSILReport', {
                    date: this.$moment(this.dateSIL).format('YYYY-MM'),
                    shopId: this.shopIdSIL,
                    companyId: this.managerCompaniesSelectedSIL,
                    withDetails: this.detailedReportSIL

                }).then(()=>{
                    this.getSILButtonLoading = false;
                   
                });
            }else{
                this.managerCompaniesSelectedSILerror = true;
            }
        }
    },
}
</script>

<style>

</style>